import apiClient from './api';

/**
 * Credit Service - API calls for credit management
 */

// Get current user's credits and history
export const getMyCredits = async (page = 1, pageSize = 50) => {
  const response = await apiClient.get('/credits/me', {
    params: { page, page_size: pageSize }
  });
  return response.data;
};

// Get current user's balance only (lightweight)
export const getMyBalance = async () => {
  const response = await apiClient.get('/credits/me/balance');
  return response.data;
};

// Get credits for a specific user by email
export const getCreditsByEmail = async (email, page = 1, pageSize = 50) => {
  const response = await apiClient.get(`/credits/${encodeURIComponent(email)}`, {
    params: { page, page_size: pageSize }
  });
  return response.data;
};

// Export current user's credit data (GDPR)
export const exportMyCredits = async () => {
  const response = await apiClient.get('/credits/me/export');
  return response.data;
};

// Sync credits from paid Zoho invoices with CR-SKU
export const syncInvoiceCredits = async () => {
  const response = await apiClient.post('/credits/me/sync-invoices');
  return response.data;
};

// Admin: Get overview of all users with credits
export const getAdminOverview = async (page = 1, pageSize = 50, search = null) => {
  const params = { page, page_size: pageSize };
  if (search) params.search = search;
  
  const response = await apiClient.get('/credits/admin/overview', { params });
  return response.data;
};

// Admin: Get full ledger with filtering
export const getAdminLedger = async (filters = {}) => {
  const response = await apiClient.get('/credits/admin/ledger', { params: filters });
  return response.data;
};

// Admin: Adjust credits for a user
export const adminAdjustCredits = async (email, amount, reason, description = null) => {
  const response = await apiClient.post('/credits/admin/adjust', {
    email,
    amount,
    reason,
    description
  });
  return response.data;
};

// Admin: Export user's credit data
export const adminExportUserCredits = async (email) => {
  const response = await apiClient.get(`/credits/admin/export/${encodeURIComponent(email)}`);
  return response.data;
};

// API: Add credits (for external apps)
export const addCredits = async (email, amount, reason, transactionId, source = 'manual', sourceReference = null) => {
  const response = await apiClient.post('/credits/add', {
    email,
    amount,
    reason,
    source,
    transaction_id: transactionId,
    source_reference: sourceReference
  });
  return response.data;
};

// API: Subtract credits (for external apps)
export const subtractCredits = async (email, amount, reason, transactionId, source = 'external_app', sourceReference = null) => {
  const response = await apiClient.post('/credits/subtract', {
    email,
    amount,
    reason,
    source,
    transaction_id: transactionId,
    source_reference: sourceReference
  });
  return response.data;
};

// Helper: Format credit amount with sign
export const formatCreditAmount = (amount) => {
  const sign = amount >= 0 ? '+' : '';
  return `${sign}${amount.toFixed(2)}`;
};

// Helper: Get transaction type label in German
export const getTransactionTypeLabel = (type) => {
  const labels = {
    'credit': 'Gutschrift',
    'debit': 'Verbrauch',
    'refund': 'Rückbuchung',
    'adjustment': 'Anpassung',
    'expiry': 'Ablauf'
  };
  return labels[type] || type;
};

// Helper: Get source label in German
export const getSourceLabel = (source) => {
  const labels = {
    'zoho_invoice': 'Zoho Rechnung',
    'zoho_payment': 'Zoho Zahlung',
    'manual': 'Manuell',
    'external_app': 'Externe App',
    'system': 'System'
  };
  return labels[source] || source;
};
